// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"94":"760c4931ad743d7a","888":"5d62c24b64f7eb0e","986":"760c4931ad743d7a"}[chunkId] + ".css";
};